import { X } from '@phosphor-icons/react'
import type { ReactNode } from 'react'

export function Drawer({ title, open, onClose, children, footer }: {
  title: string; open: boolean; onClose: () => void; children: ReactNode; footer?: ReactNode
}) {
  if (!open) return null
  return <div className="overlay" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
    <aside className="drawer" role="dialog" aria-modal="true" aria-label={title}>
      <header><div><small>乐客奢商户管理</small><h2>{title}</h2></div><button className="icon-button" onClick={onClose} aria-label="关闭"><X /></button></header>
      <button className="drawer-floating-close" type="button" onClick={onClose} aria-label="关闭"><X /></button>
      <div className="drawer-body">{children}</div>
      {footer && <footer>{footer}</footer>}
    </aside>
  </div>
}

export function Modal({ title, open, onClose, children, actions, danger = false }: {
  title: string; open: boolean; onClose: () => void; children: ReactNode; actions?: ReactNode; danger?: boolean
}) {
  if (!open) return null
  return <div className="overlay is-centered" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
    <section className={`modal ${danger ? 'is-danger' : ''}`} role="dialog" aria-modal="true" aria-label={title}>
      <header><h2>{title}</h2><button className="icon-button" onClick={onClose}><X /></button></header>
      <div className="modal-body">{children}</div>
      {actions && <footer>{actions}</footer>}
    </section>
  </div>
}
